import React, { useCallback, useEffect, useState } from "react";
import { Activity, Loader2, RefreshCw } from "lucide-react";
import { api } from "../lib/api";

export const OptionsFlowCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async (refresh = false) => {
    setBusy(true);
    try { setD((await api.get("/intel/options-flow", { params: refresh ? { refresh: true } : {}, timeout: 120000 })).data); }
    catch (e) { setD((p) => p || { rows: [] }); } finally { setBusy(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const rows = d?.rows || [], cp = d?.call_put_available;
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="options-flow-card">
      <div className="flex items-center gap-2">
        <Activity className="w-4 h-4 text-[#00F0FF]" />
        <p className="text-cyan-100 font-bold text-sm">Options Flow</p>
        <span className="text-[10px] text-cyan-200/40 truncate">{d?.source || "unusual volume"}</span>
        <button onClick={() => load(true)} disabled={busy} data-testid="options-flow-refresh" className="ml-auto text-cyan-200/60 hover:text-[#00F0FF] p-1 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
        </button>
      </div>
      {!rows.length ? <p className="text-xs text-cyan-200/40" data-testid="options-flow-empty">{busy ? "Loading…" : "No unusual-volume data right now."}</p> : (
        <table className="w-full text-[12px] nx-mono" data-testid="options-flow-table">
          <thead className="text-cyan-300/50 text-[10px] tracking-widest">
            <tr>{["SYMBOL", "PRICE", "CHANGE %", "REL VOL", ...(cp ? ["CALL/PUT"] : [])].map((h) => <th key={h} className="text-left py-1 font-normal">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.symbol} className="border-t border-white/5" data-testid={`options-flow-row-${r.symbol}`}>
                <td className="py-1 text-white font-bold">{r.symbol}</td>
                <td className="text-cyan-50/80">{r.price ?? "--"}</td>
                <td className={(r.change_pct || 0) >= 0 ? "text-emerald-300" : "text-rose-300"}>{r.change_pct != null ? `${r.change_pct > 0 ? "+" : ""}${r.change_pct}%` : "--"}</td>
                <td className="text-amber-200">{r.rel_vol != null ? `${r.rel_vol}x` : "--"}</td>
                {cp && <td className="text-cyan-50/80">{r.call_put ?? "--"}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
